// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"d1fff706","667":"31081983","843":"13da3668"}[chunkId] + ".chunk.js";
};